import { PriceStrategyUIConfigEntry } from '../types';
import { fixedMarketUIConfig } from './fixed-market';

export const rafFixedMarketUIConfig: PriceStrategyUIConfigEntry =
  fixedMarketUIConfig;
